(function () {

	'use strict';

	angular
		.module('AutoPrequal')
		.factory('ValidationFactory', validation);

	function validation() {

		var validation = {
			checkPOBox: checkPOBox
		}

		return validation;

		function checkPOBox(field, form) {
			var boxRegex = /(.*?(\bbox\b)[^$]*)$/;
			var value = field.$viewValue;
			if (boxRegex.test(value)) {
				field.$setValidity('pobox', false);
				$scope.poboxError = true;
				if (fieldName == "apStreetNum") {
					$scope.poboxErrorNum = true;
				}
				else if (fieldName == "apStreetName") {
					$scope.poboxErrorName = true;
				}
			}
			else {
				field.$setValidity('pobox', true);
				$scope.poboxError = false;
				if (fieldName == "apStreetNum") {
					$scope.poboxErrorNum = false;
				}
				else if (fieldName == "apStreetName") {
					$scope.poboxErrorName = false;
				}
			}

		}

	};

})();
